import { extendTheme } from '@chakra-ui/react'

export const themePeroni = extendTheme({
  breakpoints: {
    sm: '550px',
    md: '768px',
    lg: '960px',
    xl: '1200px',
    '2xl': '1536px',
  },
  fonts: {
    heading: 'Formata Pro',
    body: 'Formata Pro',
  },
  colors: {
    black: '#000000',
    blackSemiTransparent: '#808080',
    white: '#FFFFFF',
    transparent: 'transparent',

    primary: {
      base: '#BA0C2F',
      dark: '#540b11',
      light: '#F8E7EA',
      lightSemiTransparent: '#DFEDDD80',
    },
    teal: '#66964F',
    // #BDC8BB
    // #AAB9A7
    accent: '#BA0C2F',
    sand: '#F5F3EE',
    red: '#C6243E',
    // grey: '#EBEBEB',
    grey: {
      base: '#EBEBEB',
      dark: '#DCDCDC',
    },
    yellow: '#F8CA27',
    // #727272
    // #B7B7B7
    // #DCDCDC
    success: '#66964F',

    header: {
      bg: '#ffffff',
      borderColor: '#EBEBEB',
      rightOfLogoBorder: '#EBEBEB',
    },
  },
  styles: {
    global: {
      body: {
        bg: 'grey.base',
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        textTransform: 'uppercase',
        fontSize: 'xs',
        lineHeight: '6',
        outline: 'none',
        fontWeight: '500',
        borderRadius: 'base',
        _focus: {
          boxShadow: 'none',
        },
      },
      sizes: {
        md: {
          fontSize: 'xs',
        },
      },
      variants: {
        primary: {
          border: '1px solid',
          borderColor: 'primary.base',
          bg: 'primary.base',
          px: 8,
          py: 2,
          color: 'white',
          _hover: {
            borderColor: 'primary.dark',
            bg: 'primary.dark',
            _disabled: {
              bg: 'primary.base',
              borderColor: 'primary.base',
            },
          },
          _focus: {
            borderColor: 'primary.dark',
            bg: 'primary.dark',
            boxShadow: 'none',
          },
          _active: {
            borderColor: 'primary.dark',
            bg: 'primary.dark',
          },
        },
        secondary: {
          border: '1px solid',
          borderColor: 'grey.base',
          bg: 'transparent',
          px: 8,
          py: 2,
          color: 'primary.base',
          _hover: {
            borderColor: 'primary.base',
            bg: 'primary.base',
            color: 'white',
            _disabled: {
              bg: 'transparent',
              color: 'primary.base',
              borderColor: 'grey.base',
            },
          },
          _focus: {
            borderColor: 'primary.base',
            bg: 'primary.base',
            color: 'white',
            boxShadow: 'none',
          },
          _active: {
            borderColor: 'primary.base',
            bg: 'primary.base',
            color: 'white',
          },
        },
        tertiary: {
          border: '1px solid',
          borderColor: 'sand',
          bg: 'sand',
          color: 'accent',
          _hover: {
            borderColor: 'sand',
            bg: 'sand',
            color: 'accent',
          },
          _focus: {
            borderColor: 'sand',
            bg: 'sand',
            color: 'accent',
            boxShadow: 'none',
          },
          _active: {
            borderColor: 'sand',
            bg: 'sand',
            color: 'accent',
          },
        },
        danger: {
          border: '1px solid',
          borderColor: 'grey.base',
          bg: '#fff',
          px: 8,
          color: 'red',
          _hover: {
            borderColor: 'red',
            bg: 'red',
            color: 'white',
            _disabled: {
              bg: '#fff',
              color: 'red',
              borderColor: 'grey.base',
            },
          },
          _focus: {
            borderColor: 'red',
            bg: 'red',
            color: 'white',
            boxShadow: 'none',
          },
          _active: {
            borderColor: 'red',
            bg: 'red',
            color: 'white',
          },
        },
        dangerSolid: {
          border: '1px solid',
          borderColor: 'red',
          bg: 'red',
          px: 8,
          color: '#fff',
          _hover: {
            borderColor: 'red',
            bg: '#fff',
            color: 'red',
            _disabled: {
              bg: 'red',
              color: '#fff',
              borderColor: 'red',
            },
          },
          _focus: {
            borderColor: 'red',
            bg: '#fff',
            color: 'red',
            boxShadow: 'none',
          },
          _active: {
            borderColor: 'red',
            bg: 'red',
            color: 'white',
          },
        },
        link: {
          color: 'primary.base',
          _hover: {
            textDecoration: 'underline',
          },
        },
      },
      defaultProps: {
        size: 'md',
        variant: 'primary',
      },
    },
    Heading: {
      baseStyle: {
        color: 'accent',
        fontWeight: '400',
      },
      sizes: {
        h1: {
          fontSize: 'xl',
        },
        h2: {
          fontSize: 'md',
        },
        h3: {
          color: 'black',
          fontSize: 'md',
          fontWeight: '500',
        },
      },
      defaultProps: {
        size: 'h1',
      },
    },
    FormLabel: {
      baseStyle: {
        color: 'black',
        opacity: '0.5',
        fontSize: 'xs',
        fontWeight: '400',
      },
    },
    Input: {
      variants: {
        outline: {
          field: {
            border: '1px solid',
            borderColor: 'grey.base',
            borderRadius: 'base',
            _hover: {
              borderColor: 'grey.base',
            },
            _focus: {
              borderColor: 'primary.base',
              boxShadow: 'none',
            },
          },
        },
      },
    },
    NumberInput: {
      variants: {
        outline: {
          field: {
            border: '1px solid',
            borderColor: 'grey.base',
            borderRadius: 'base',
            _hover: {
              borderColor: 'grey.base',
            },
            _focus: {
              borderColor: 'primary.base',
              boxShadow: 'none',
            },
          },
        },
      },
    },
    Textarea: {
      variants: {
        outline: {
          border: '1px solid',
          borderColor: 'grey.base',
          borderRadius: 'base',
          _hover: {
            borderColor: 'grey.base',
          },
          _focus: {
            borderColor: 'primary.base',
            boxShadow: 'none',
          },
        },
      },
    },
    Select: {
      variants: {
        outline: {
          field: {
            border: '1px solid',
            borderColor: 'grey.base',
            borderRadius: 'base',
            _hover: {
              borderColor: 'grey.base',
            },
            _focus: {
              borderColor: 'primary.base',
              boxShadow: 'none',
            },
          },
        },
      },
    },
    Checkbox: {
      sizes: {
        md: {
          icon: {
            height: 2,
          },
        },
        xl: {
          control: {
            width: 6,
            height: 6,
          },
          icon: {
            height: 2.5,
          },
        },
      },
      variants: {
        default: {
          control: {
            border: '1px solid',
            borderColor: 'grey.base',
            borderRadius: 'base',
            _focus: {
              boxShadow: 'none',
              borderColor: 'primary.base',
            },
            _checked: {
              backgroundColor: 'primary.base',
            },
          },
          icon: {
            color: 'white',
          },
        },
        round: {
          control: {
            border: '1px solid',
            borderColor: 'lightGrey',
            borderRadius: 'full',
            _focus: {
              boxShadow: 'none',
              borderColor: 'success',
            },
            _checked: {
              borderColor: 'success',
              backgroundColor: 'success',
            },
          },
          icon: {
            color: 'white',
          },
        },
      },
      defaultProps: {
        size: 'xl',
        colorScheme: 'transparent',
        variant: 'default',
      },
    },
    Modal: {
      baseStyle: {
        header: {
          fontWeight: 500,
          px: 10,
          pt: 10,
        },
        body: {
          px: 10,
          pb: 10,
        },
        footer: {
          px: 10,
          pb: 10,
          pt: 0,
        },
        closeButton: {
          top: 4,
          right: 4,
          _focus: {
            boxShadow: 'none',
          },
        },
      },
      defaultProps: {
        size: '3xl',
      },
    },
    Tooltip: {
      baseStyle: {
        fontWeight: '400',
        bg: 'black',
        color: 'white',
        borderRadius: 'base',
        fontSize: 'sm',
      },
    },
    Menu: {
      baseStyle: {
        button: {
          _hover: {
            borderColor: 'red',
            bg: 'white',
          },
          _active: {
            borderColor: 'red',
            bg: 'white',
          },
        },
        list: {
          py: 0,
          overflow: 'hidden',
          borderColor: 'grey.base',
        },
        item: {
          fontWeight: '400',
          bg: 'white',
          color: 'black',
          fontSize: '14px',
          py: 4,
          pl: 6,
          pr: 4,
          _hover: {
            bg: 'primary.light',
            color: 'primary.base',
          },
          _focus: {
            bg: 'primary.light',
            color: 'primary.base',
          },
        },
        divider: {
          my: 0,
          ml: 6,
          mr: 1,
          borderColor: 'grey.base',
        },
      },
      defaultProps: {
        autoSelect: false,
      },
    },
    Tabs: {
      baseStyle: {
        indicator: {
          bg: 'transparent',
        },
      },
      variants: {
        line: {
          root: {
            borderColor: 'transparent',
          },
          tab: {
            borderBottomWidth: '2px',
            borderColor: 'transparent',
            color: 'primary.base',
            px: 6,
            _focus: {
              outline: 'none',
              boxShadow: 'none',
              bg: 'white',
            },
            _hover: {
              bg: 'sand',
              borderColor: 'primary.base',
            },
            _active: {
              bg: 'sand',
              borderColor: 'primary.base',
            },
            _selected: {
              bg: 'white',
              borderColor: 'primary.base',
            },
          },
        },
        unstyled: {
          root: {
            borderColor: 'transparent',
          },
          tab: {
            color: 'blackSemiTransparent',
            bg: 'white',
            borderBottomWidth: '1px',
            borderColor: 'transparent',
            px: 0,
            mr: 8,
            _focus: {
              outline: 'none',
              boxShadow: 'none',
              bg: 'white',
            },
            _hover: {
              bg: 'white',
              color: 'primary.base',
              borderColor: 'primary.base',
            },
            _active: {
              bg: 'white',
              borderColor: 'primary.base',
            },
            _selected: {
              color: 'primary.base',
              borderColor: 'primary.base',
            },
          },
        },
      },
      defaultProps: {
        colorScheme: 'accent',
      },
    },
    Radio: {
      variants: {
        primary: {
          control: {
            _checked: {
              backgroundColor: 'primary.base',
              borderColor: 'primary.base',
            },
            _focus: {
              boxShadow: 'none',
            },
          },
          label: {
            fontSize: 'sm',
          },
        },
      },
      defaultProps: {
        variant: 'primary',
        colorScheme: 'primary',
        size: 'lg',
      },
    },
  },
})
